<template>
	<div class="box">
		<PageHeader @back="goback" :content="'答卷审核'" />
		<el-row :gutter="24">
			<el-col :span="18">
				<div class="content-box">
					<div class="content-header">
						<div class="label">查看报表</div>
						<el-button type="text" @click="viewAuditReport">查看审核报表</el-button>
					</div>
					<div class="content-body ">
						<div class="question" 
							:style="{ 
								'width': (imgList.length == 0 && center.length == 0) 
								? '100%' 
								: 'calc(100% - 120px - 20px)' 
							}">
							<AppearancePC
								v-if="data && data.questionsList.length > 0 && style.subjectColor"
								ref="AppearancePC"
								:key="wid"
								@addEventListener="handleonmousedown"
								:quanxian="quanxian"
								:bandingstyle="style"
								:data="data"
								:quotaList="quotaList"
								@submit="submit"
							></AppearancePC>
						</div>
						<div class="flie-box">
							<!-- 图片 -->
							<el-badge v-if="imgList.length > 0" :value="imgList.length" class="img-box">
								<el-image class="img" fit="cover" :src="url" :preview-src-list="imgList">
									<div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
								</el-image>
							</el-badge>

							<div v-if="center.length > 0" class="map-box" @click="viewMap"><div class="map-icon"></div></div>
						</div>
					</div>
					<div class="content-footer">
						<div style="width: 100%;width: calc(100% - 240px);">
							<div class="audio-box" v-show="audioList.length > 0">
								<!-- 音频 -->
								<span class="last" @click="playLast">上一首</span>
								<el-slider class="slider" :max="musicValueMax" v-model="musicValue" :show-tooltip="false" :step="0.2" @change="sliderChange"></el-slider>
								<audio :src="audioList[audioIndex]" ref="audio" id="audio" @ended="overAudio"></audio>

								<i class="el-icon-video-pause audio-icon" v-if="isPlay" @click="handlePlay"></i>
								<i class="el-icon-video-play audio-icon" v-else @click="handlePlay"></i>

								<span class="next" @click="playNext">下一首</span>
								<span class="num">(共{{ audioList.length }}首)</span>
							</div>
						</div>
						<div class="btn">
							<!-- 审核按钮 -->
							<el-button size="medium" type="primary" :disabled="auditState != 0" @click="approved">审核通过</el-button>
							<el-button size="medium" type="danger" :disabled="auditState != 0" @click="reviewRemarks = true">审核失败</el-button>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="content-box">
					<div class="content-header"><div class="label">待审核样本</div></div>
					<div class="to-be-reviewed-body">
						<el-row :gutter="12" class="row">
							<el-col :span="12">
								<el-select size="medium" v-model="sampleValue" placeholder="请选择">
									<el-option v-for="item in sampleList" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-col>
							<el-col :span="12"><el-input size="medium" v-model="sampleNoValue" placeholder="请输入样本编号"></el-input></el-col>
						</el-row>
						<el-date-picker
							size="medium"
							class="row"
							v-model="dateValue"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-ddTHH:mm:ss.000Z"
							type="datetimerange"
							range-separator="-"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						></el-date-picker>
						<div class="row btn">
							<el-button size="medium" type="primary" @click="toSearch">搜索</el-button>
							<el-button size="medium" type="danger" @click="toReset">重置</el-button>
						</div>
						<div class="row tag-box">
							<p class="tag">全部：<span>{{ quantityInfo.allTimes || 0}}</span></p>
							<p class="tag">待审核：<span>{{ quantityInfo.checkPending || 0}}</span></p>
						</div>
						<div :gutter="12" class="row tag-box">
							<p class="tag" :span="12">通过：<span>{{ quantityInfo.successTimes || 0}}</span></p>
							<p class="tag" :span="12">未通过：<span>{{ quantityInfo.failTimes || 0}}</span></p>
						</div>
						<el-table height="254" class="scroll-body" :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
							<el-table-column prop="autoId" align="center" label="样本编号"></el-table-column>
							<el-table-column prop="name" align="center" label="状态">
								<template slot-scope="scope">
									<!-- 待完成 -->
									<el-tag v-if="scope.row.auditState == 0">未审核</el-tag>
									<el-tag v-else-if="scope.row.auditState == 1" type="success">通过</el-tag>
									<el-tag v-else-if="scope.row.auditState == 2" type="warning">未通过</el-tag>
								</template>
							</el-table-column>
							<el-table-column width="100" align="center" label="操作">
								<template slot-scope="scope">
									<el-link :underline="false" type="primary" @click="toExamine(scope.row)">{{ scope.row.auditState != 0 ? '查看' : '开始审核' }}</el-link>
								</template>
							</el-table-column>
						</el-table>
						<div class="page-box">
							<el-pagination
								:pager-count="5"
								:current-page="pageIndex"
								:page-size="10"
								background
								layout="prev, pager, next"
								:total="totals"
								@current-change="handleCurrentChange"
							></el-pagination>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>

		<el-row :gutter="24">
			<el-col :span="24">
				<div class="content-box">
					<div class="content-header">
						<div class="label">样本详情</div>
						<el-button type="text" size="medium" icon="el-icon-setting" @click="setShowField">设置显示字段</el-button>
					</div>
					<div class="sample-body">
						<el-descriptions title="" :column="5">
							<el-descriptions-item v-for="item in sampleShowList" :key="item.enfieldName" :label="item.chfieldName">{{audioInfo[item.enfieldName] || '--'}}</el-descriptions-item>
						</el-descriptions>
					</div>
				</div>
			</el-col>
		</el-row>
		<!-- 地图 -->
		<el-dialog title="位置" :visible.sync="viewMapDialog" width="30%" :close-on-click-modal="false">
			<el-amap vid="amapDemo" :center="center" :zoom="zoom" class="amap-demo">
				<el-amap-marker :position="marker.position" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
			</el-amap>
		</el-dialog>
		<!-- 设置显示字段 -->
		<el-dialog title="设置显示字段" :visible.sync="showFieldDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
			<div class="field-content">
				<div class="field-box">
					所有字段：
					<span class="tips">(将当前字段拖入显示字段框中)</span>
					<el-card shadow="never">
						<draggable class="draggable" :group="{ name: 'piece', pull: 'clone', put: true }" v-model="sampleAllList" animation="300" v-bind="draggableOptions" @sort="changeSortAllList">
							<p class="handle" v-for="tag in sampleAllList" :key="tag.enfieldName">{{ tag.chfieldName }}</p>
						</draggable>
					</el-card>
				</div>
				<div class="field-box">
					显示字段：
					<el-card shadow="never">
						<draggable class="draggable2" :group="{ name: 'piece', pull: true, put: true }" v-model="sampleShowEditingList" animation="300"  v-bind="draggableOptions" @sort="changeSort">
							<p class="handle" v-for="tag in sampleShowEditingList" :key="tag.enfieldName">{{ tag.chfieldName }}</p>
						</draggable>
					</el-card>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="cancelSetField">取 消</el-button>
				<el-button size="medium" type="primary" @click="okSetField">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 审核失败备注 -->
		<el-dialog title="备注" :visible.sync="reviewRemarks" width="30%" :before-close="handleCloseNote" :close-on-click-modal="false">
			<el-input type="textarea" :rows="6" placeholder="请编辑审核不通过原因" resize="none" v-model="noteValue"></el-input>
			<div slot="footer" class="remarks-dialog-footer dialog-footer">
				<el-checkbox v-model="isCallBack">允许访员回拨补录</el-checkbox>
				<div>
					<el-button size="medium" @click="noteClearing">取 消</el-button>
					<el-button size="medium" type="primary" @click="OKnote">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import AppearancePC from '@/page/myQuestionnaire/components/userAnswer/appearancePC.vue';
import PageHeader from '@/components/pageHeader.vue';
import { SetAnswer } from '@/page/myQuestionnaire/js/userAnswer/setAnswer';
import { GetAnswerList } from '@/page/myQuestionnaire/js/userAnswer/getAnswerList';
import { doVerifyQuota } from '@/page/myQuestionnaire/js/userAnswer/doVerifyQuota';
export default {
	name: 'SampleReview',
	components: {
		draggable,
		AppearancePC,
		PageHeader
	},
	data() {
		return {
			url: '',
			imgList: [],
			viewMapDialog: false,
			zoom: 13,
			center: [],
			marker: {
				position: []
			},
			musicValue: 0,
			musicValueMax: 0,
			isPlay: false,
			mySound: {},
			audioList: [],
			audioIndex: 0,
			sampleAllList: [],
			sampleShowList: [],
			sampleShowEditingList: [],
			showFieldDialog: false,
			draggableOptions: {
				handle: '.handle'
			},
			sampleList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '待审核',
					value: 0
				},
				{
					label: '通过',
					value: 1
				},
				{
					label: '未通过',
					value: 2
				}
			],
			sampleNoList: [],
			sampleValue: '',
			sampleNoValue: '',
			dateValue: '',
			tableData: [],
			pageIndex: 1,
			totals: 0,
			allSampleList: [],
			// questionList: [],
			beginTime: '',
			endTime: '',
			sampleId: '',
			userId: '', // 样本访员id
			auditState: '',
			reviewRemarks: false,
			noteValue: '',
			isCallBack: false, // 是否允许访员回拨补录
			quantityInfo: {},
			audioTime: {},
			audioInfo: {},
			activeSampleId: '',
			quanxian: {
				"id": "af5234a93bd24893b3f5ccd8f331a27b",
				"wjTitle": "<p style=\"text-align: center;\"><span style=\"font-size: 20px\"><strong><span style=\"color: #10ab97;\">问卷回显</span></strong></span></p>",
				"appearanceId": "",
				"content": "感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！",
				"wjType": "问卷类型",
				"startTime": "",
				"endTime": "",
				"createId": "fbb957c37ff345bc9705877bf7bcaaee",
				"modifyId": "",
				"mechanismId": "",
				"modifyTime": "2025-10-23 10:08:14",
				"createTime": "2025-10-22 11:36:28",
				"delTag": 0,
				"useNumber": 1,
				"isOpen": 0,
				"handleMode": "",
				"versionNumber": "",
				"state": 2,
				"wxLimit": 0,
				"wxLimitNumber": 1,
				"pcLimit": 0,
				"pcLimitNumber": 1,
				"ipLimit": 0,
				"ipLimitNumber": 1,
				"startUpPassword": 0,
				"startUpPasswordNumber": "",
				"limitPhone": 0,
				"onlyEmail": 0,
				"setStartEndTime": 0,
				"onlyWx": 0,
				"recordWxUser": 0,
				"setAnswerLimit": 0,
				"setAnswerLimitNumber": 0,
				"ifQuote": 0,
				"quoteNumber": 0,
				"quoteQuestionnaireId": "",
				"isRandom": 0,
				"pictureAddress": "defaulttemplate.png",
				"rejectReason": "",
				"newMsgtoWX": 0,
				"newMsgtoEmail": 0,
				"email": "",
				"collectionMethod": 0,
				"grantMethod": 0,
				"shareLogo": 0,
				"prohibitWXShare": 0,
				"bindWX": "",
				"bindEmail": "",
				"breakpointAnswer": 0,
				"ifAnswerDataLimit": 0,
				"answerDataLimit": "",
				"ifPageAnswerTime": 0,
				"pageAnswerTime": "",
				"ifScreeningPage": 0,
				"ifQuota": 0,
				"ifRuleFilter": 0,
				"ifAllowStatistics": 0,
				"ifDisplayShare": 1,
				"ifWechatRedPacket": 0,
				"ifCustomDraw": 0,
				"wxLimitFreq": 0,
				"pcLimitFreq": 0,
				"ipLimitFreq": 0,
				"ifCustomJump": 0,
				"customJump": 0,
				"manyThanks": "您的答卷已提交，感谢您的参与！",
				"skipUrl": "",
				"shareSeoIndex": 0,
				"hideLogo": "",
				"subjectColor": "#0080ff",
				"phoneUnique": 0,
				"earlyTerminationTAG": "非常抱歉，您不适合本次调查的人群条件，感谢您的参与",
				"issueTime": "2025-10-23 10:08:15",
				"ifanswerPlaza": 0,
				"versions": 8,
				"randomSurveyId": "7145562614",
				"isBanModifyPhone": 0,
				"isHidePhone": 0,
				"accessprotModifySample": 0,
				"isEnableCallControl": 0,
				"callControlSum": 0,
				"isEnableAppointmentMinuteHint": "",
				"appointmentMinuteSum": 0,
				"isPutSampleReadIntervalTime": "",
				"putSampleReadIntervalTimeSum": "",
				"pretaskcode": "",
				"dialsearchtype": 1,
				"rate": 0.15,
				"isEntry": 0,
				"isStaging": 0,
				"isEnableSible": 0,
				"sibleScoringFormula": "",
				"finallyTime": "",
				"isEnableSibleScoringFormula": 0,
				"validDay": 0,
				"randomJson": "",
				"copyrightConfigContent": "",
				"copyrightConfig": 0,
				"wxshareContent": "大家一起来参与吧！",
				"wxsharePicture": "aixuelogo.png",
				"wxshareTitle": "<p style=\"text-align: center;\"><span style=\"font-size: 20px\"><strong><span style=\"color: #10ab97;\">问卷标题</span></strong></span></p>"
			},
			style: {
				"appearance": {
					"id": "1980840651361611777",
					"sourceStyle": 1,
					"questionnaireId": "af5234a93bd24893b3f5ccd8f331a27b",
					"coverSet": 1,
					"coverImg": "",
					"coverColor": "",
					"titleDisplay": 1,
					"titleLocation": 1,
					"titleSize": 24,
					"fontColor": "",
					"startState": 0,
					"buttonColor": "",
					"buttonFontColor": "",
					"headerState": 0,
					"headerType": 0,
					"headerContent": "",
					"headerImg": "",
					"headerColor": "",
					"headerBold": "",
					"headerItalic": "",
					"headerUnderline": "",
					"headerSize": 16,
					"headerAlign": "left",
					"headerBgcolor": "",
					"bgState": 0,
					"bgImg": "",
					"bgLocation": "repeat",
					"bgQuestionnaire": "",
					"bgOpacity": 100,
					"bgColor": "#F5F5F5",
					"logoSet": "",
					"logoLocation": "left",
					"logoImg": "",
					"fontTitleSize": 36,
					"fontWelcomeSize": 14,
					"fontStemSize": 16,
					"fontOptionSize": 14,
					"fontEndSize": 16,
					"startButton": "",
					"buttonContent": "提交",
					"displayTitle": 1,
					"displayWelcome": 1,
					"displayQuestionsno": 1,
					"submitButtonColor": "#0080FF",
					"markedWords": 0,
					"fontTitleColor": "",
					"fontTitleBold": "",
					"fontTitleItalic": "",
					"fontTitleUnderline": "",
					"fontWelcomeColor": "",
					"fontWelcomeBold": "",
					"fontWelcomeItalic": "",
					"fontWelcomeUnderline": "",
					"fontStemColor": "",
					"fontStemBold": "",
					"fontStemItalic": "",
					"fontStemUnderline": "",
					"fontOptionColor": "",
					"fontOptionBold": "",
					"fontOptionItalic": "",
					"fontOptionUnderline": "",
					"fontEndColor": "",
					"fontEndBold": "",
					"fontEndItalic": "",
					"fontEndUnderline": ""
				},
				"subjectColor": "#0080ff"
			},
			data: {
				questionsList: []
			},
			quotaList: []
		};
	},
	computed: {
		wid() {
			return sessionStorage.getItem('wid') || 0;
		},
		systemSource() {
			let state;
			if (this.$route.query.source == 'df') {
				state = 2;
			} else if (this.$route.query.source == 'mf') {
				state = 1;
			}
			return state;
		},
		selectIndex() {
			let state;
			if (this.$route.query.source == 'df') {
				state = 3;
			} else if (this.$route.query.source == 'mf') {
				state = 4;
			}
			return state;
		},
		// 答题中收集配额试题列表
		quotatypeList() {
			console.log(this.quotaList);
			let data = this.quotaList.filter(info => {
				return info.ruleType == 2;
			});
			return data;
		},
	},
	created() {
		console.log(this.systemSource);
		if (!this.wid) {
			this.goback();
		} else {
			this.getAllData();
			this.getShwoField();
			this.getSampleTjNumber();
			this.getData()
		}
		// console.log(this.questionList);
	},
	methods: {
		getData() {
			let data = {
				surveyId: this.wid,
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryPaperConfig}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.quotaList = res.resultBody.questionnaireNewQuotaList
					} else {
						that.quotaList = []
					}
					console.log('that.quotaList :>> ', that.quotaList);
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		handleonmousedown(state) {
			console.log('强制交卷', state)
		},
				// 交卷
		/**
		 * @param answerState 答题状态 6完成 14配额已满 4问卷无效
		 * @param quotaTips 交卷后提示
		 * @param quotaId 配额id
		 */
		async submit(answerState, quotaTips) {
			console.log('交卷', answerState, quotaTips)
			// return
			this.loading = true;
			this.submitloading = this.$t('UserAnswer.Submitting');
			let answerList = await GetAnswerList(this.data.questionsList);
			console.log(answerList)
			if (this.quotatypeList.length > 0) {
				answerState = await doVerifyQuota(this.data.questionsList, this.quotatypeList);
			}
			// console.log('答题结果--------');
			// console.log(answerList);
			// console.log(JSON.stringify(answerList));
			// console.log('答题结果--------');

			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.saveAnswer}`,
				method: 'POST',
				data: {
					surveyId: this.wid,
					result: JSON.stringify(answerList),
					id: this.activeSampleId,
					answerState: answerState ? answerState : 6,
					isAudit: 1, // 是否为审核提交:0否，1是
				},
				cb(res) {
					that.loading = false;
					// console.log(res)
					if (res.code == '0') {
						if (answerState == 14 || answerState == 6 || answerState == 3) {
							if (quotaTips) {
								that.quotaTips = quotaTips;
							}
						}
						that.endMsg = answerState == 4 ? that.endPageAdvanceMsg : that.endPageNormalMsg
						that.dialogthinkVisible = true;
						// 暂存
						if (answerState == 3) {
							that.setStaging()
						} else if (localStorage.getItem(that.id)) {
							localStorage.removeItem(that.id);
						}
						if (that.continueDialogVisible == true) {
							that.continueDialogVisible = false;
						}
						// 开启（每台设备答题次数）
						// if (that.quanxian.pcPhoneAnswerNumState == 1) {
						//     let num = localStorage.getItem(`${that.id}Num`)
						//     localStorage.setItem(`${that.id}Num`, parseInt(num) + 1)
						// }
						if (that.quanxian.ifCustomJump == 1) {
							// 开启跳转
							if (that.quanxian.customJump == 1) {
								// 跳转链接
								window.location.href= that.quanxian.skipUrl;
							}
						}
						that.continueBeforClose();
						that.cutScreenCheckRemove();
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		getSampleTjNumber() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFinishSampleTjNumber}`,
				method: 'POST',
				data: {
					qid: this.wid,
					sampleCode: this.sampleNoValue,
					beginTime: this.beginTime,
					endTime: this.endTime,
					systemSource: this.systemSource
				},
				cb(res) {
					// console.log(res);
					if (res.code == 0) {
						that.quantityInfo = res.resultBody;
					}
				}
			};
			this.$util.request(params);
		},

		handleCloseNote() {
			this.noteValue = '';
			this.reviewRemarks = false;
		},
		noteClearing() {
			this.noteValue = '';
			this.reviewRemarks = false;
		},
		OKnote() {
			this.auditApi(2);
		},
		handleCurrentChange(e) {
			this.pageIndex = e;
			this.getAllData();
		},
		goback() {
			this.$router.go(-1)
		},
		getShwoField() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAuditPageShowField}`,
				method: 'POST',
				data: {
					qid: this.wid
				},
				cb(res) {
					// console.log(res);
					if (res.code == 0) {
						if (res.resultBody) {
							that.sampleShowList = JSON.parse(res.resultBody.enFieldName);
							that.sampleShowEditingList = JSON.parse(res.resultBody.enFieldName);
						}
					} else {
						that.sampleShowList = [];
						that.sampleShowEditingList = []
					}
				}
			};
			this.$util.request(params);
		},
		getAllData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFinishSample}`,
				method: 'POST',
				data: {
					qid: this.wid,
					// userId: this.userId,
					sampleCode: this.sampleNoValue, // 样本编号
					beginTime: this.beginTime, // 开始时间
					endTime: this.endTime, // 结束时间
					auditState: this.sampleValue, // 审核状态
					currentPage: this.pageIndex, // 当前页
					pageSize: 10, // 每页多少条
					systemSource: this.systemSource
				},
				cb(res) {
					// console.log(res);
					if (res.code == 0) {
						that.tableData = res.resultBody.records;
						if (that.tableData.length > 0) {
							that.toExamine(that.tableData[0]);
						}
						that.totals = res.resultBody.total;
					} else {
						// console.log('qingqiu ');
						that.tableData = [];
						that.totals = 0;
					}
				}
			};
			this.$util.request(params);
		},
		viewMap() {
			console.log(this.marker);
			this.viewMapDialog = true;
			// 后端返回的经纬度赋值
			// this.center = [116.486635, 40.009326]
			// this.marker.position = [116.486635, 40.009326]
		},
		sliderChange() {
			this.$refs.audio.currentTime = this.musicValue;
			this.play();
		},
		overAudio() {
			this.isPlay = false;
			clearInterval(this.audioTime);
			this.musicValue = this.musicValueMax;
		},
		handlePlay() {
			this.mySound.src = 'https://gv-sycdn.kuwo.cn/a84cea5f5a855dac5f750fbe8ec27bd7/6347b40c/resource/n2/55/9/612742845.mp3'; //音乐的路径
			// console.log(this.isPlay)
			if (this.isPlay == false) {
				this.play();
			} else {
				this.stop();
			}
		},
		play() {
			this.isPlay = true;
			this.$refs.audio.play();
			this.audioTime = setInterval(() => {
				this.musicValue = this.$refs.audio.currentTime;
			}, 1000);
			this.musicValueMax = this.$refs.audio.duration;
		},
		stop() {
			// console.log(this.$refs.audio)
			this.isPlay = false;
			this.$refs.audio.pause();
			// this.$refs.audio.currentTime = 0;
		},
		playLast() {
			if (this.audioIndex > 0) {
				this.audioIndex--;
				this.mySound.src = this.audioList[this.audioIndex];
				this.musicValue = 0;
				this.musicValueMax = 0;
				this.play();
			} else {
				this.$message({
					message: '已经是第一首了',
					type: 'warning'
				});
			}
		},
		playNext() {
			if (this.audioIndex < this.audioList.length - 1) {
				this.audioIndex++;
				this.mySound.src = this.audioList[this.audioIndex];
				this.musicValue = 0;
				this.musicValueMax = 0;
				this.play();
			} else {
				this.$message({
					message: '已经最后一首了',
					type: 'warning'
				});
			}
		},
		approved() {
			// 调用审核接口
			this.auditApi(1);
		},
		auditApi(state) {
			console.log(this.userId);
			let isCallBack = this.isCallBack == true ? 1 : 0;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.aduitsample}`,
				method: 'POST',
				data: {
					qid: this.wid,
					sampleCode: this.sampleId, // 样本编号
					userId: this.userId, // 访员id
					auditState: state, // 样本状态
					remark: this.noteValue,
					isCallBack: state == 2 ? isCallBack : ''
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.noteValue = '';
						that.reviewRemarks = false;

						that.getAllData();
						that.getSampleTjNumber();
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			this.$util.request(params);
		},
		setShowField() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.wid
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						console.log(res.resultBody.questionsFieldMappings)
						let arr = [
							'样本状态',
							'答题 IP',
							'答题用户id',
							'浏览器',
							'操作系统'
						]
						that.sampleAllList = res.resultBody.questionsFieldMappings.filter((info) =>{
							return arr.indexOf(info.chfieldName) == -1
						})
						const showListFields = new Set(that.sampleShowEditingList.map(item => item.enfieldName));
						that.sampleAllList = that.sampleAllList.filter(item => 
							!showListFields.has(item.enfieldName)
						);
					} else {
						that.sampleAllList = []
					}
				}
			};
			this.$util.request(params);
			this.sampleShowEditingList = [...this.sampleShowList];
			this.showFieldDialog = true;
		},
		cancelSetField() {
			this.sampleShowEditingList = [];
			this.showFieldDialog = false;
		},
		okSetField() {
			this.sampleShowList = [...this.sampleShowEditingList];
			let arr = [];
			this.sampleShowList.forEach(info => {
				arr.push({
					enfieldName: info.enfieldName,
					chfieldName: info.chfieldName
				});
			});
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setAuditPageShowField}`,
				method: 'POST',
				data: {
					qid: this.wid,
					fieldValue: JSON.stringify(arr) // 样本编号
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.$message({
							message: res.message,
							type: 'success'
						});
					}
				}
			};
			this.$util.request(params);
			this.showFieldDialog = false;
		},
		changeSort(evt) {
			// 检查是否是跨区域拖拽
			if (evt && evt.from.className == 'draggable') {
				// 跨区域拖拽：从左侧拖到右侧
				this.removeDuplicatesAndSync('right');
			}
		},
		changeSortAllList(evt) {
			if (evt && evt.from.className == 'draggable2') {
				// 跨区域拖拽：从右侧拖到左侧
				this.removeDuplicatesAndSync('left');
			}
		},
		removeDuplicatesAndSync(direction) {
			console.log('direction :>> ', direction);
			if (direction === 'right') {
				// 从左侧拖到右侧的处理
				this.sampleShowEditingList = this.removeDuplicates(this.sampleShowEditingList, 'enfieldName');
				
				// 同步更新左侧列表
				const editingFields = new Set(this.sampleShowEditingList.map(item => item.enfieldName));
				this.sampleAllList = this.sampleAllList.filter(item => !editingFields.has(item.enfieldName));
				
			} else if (direction === 'left') {
				// 从右侧拖到左侧的处理
				this.sampleAllList = this.removeDuplicates(this.sampleAllList, 'enfieldName');
				
				// 同步更新右侧列表
				const allFields = new Set(this.sampleAllList.map(item => item.enfieldName));
				this.sampleShowEditingList = this.sampleShowEditingList.filter(item => !allFields.has(item.enfieldName));
			}
			
		},

		// 通用的去重方法
		removeDuplicates(array, key) {
			const uniqueMap = new Map();
			const duplicates = [];
			
			const result = array.reduce((acc, item) => {
				const keyValue = item[key];
				if (!uniqueMap.has(keyValue)) {
					uniqueMap.set(keyValue, true);
					acc.push(item);
				} else {
					duplicates.push(keyValue);
				}
				return acc;
			}, []);
			
			// 输出重复项警告
			if (duplicates.length > 0) {
				console.warn(`过滤掉重复项: ${duplicates.join(', ')}`);
			}
			
			return result;
		},
		toSearch() {
			this.endTime = '';
			this.beginTime = '';
			// 调用接口并刷新页面数据
			if (this.dateValue && this.dateValue.length > 0) {
				this.endTime = this.dateValue[0];
				this.beginTime = this.dateValue[1];
			}
			this.getAllData();
			this.getSampleTjNumber();
		},
		toReset() {
			this.sampleValue = '';
			this.sampleNoValue = '';
			this.dateValue = '';
		},
		tableRowClassName({ row, rowIndex }) {
			if (this.activeSampleId == row.id) {
				return 'success-row';
			}
			return '';
		},
		toExamine(item) {
			this.activeSampleId = item.id;
			this.sampleId = item.autoId;
			this.auditState = item.auditState;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFinishSampleById}`,
				method: 'POST',
				data: {
					qid: this.wid,
					sampleCode: item.id // 样本编号
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
                        that.imgList = []
                        that.url = ''
                        that.audioList = []
                        that.center = []
                        that.marker.position = []
                        if (res.resultBody.answerPhoto) {
                            let arr = []
                            arr = JSON.parse(res.resultBody.answerPhoto)
                            arr.forEach((info, index) => {
                                // console.log(info)
                                that.imgList.push(info.key)
                                if (index == 0) {
                                    that.url = info.key
                                }
                            })
                        }
                        // console.log(that.url)
                        if (res.resultBody.answerVoice) {
                            let arr = []
                            arr = JSON.parse(res.resultBody.answerVoice)
                            arr.forEach((info) => {
                                that.audioList.push(info.key)
                                setTimeout(() => {  
                                    that.musicValueMax = that.$refs.audio.duration
                                }, 1000)
                            })
                        }
                        if (res.resultBody.recordFile) {
                            res.resultBody.recordFile.forEach((info) => {
                                that.audioList.push(info)
                                setTimeout(() => {  
                                    that.musicValueMax = that.$refs.audio.duration
                                }, 1000)
                            })
                        }
                        // console.log( `that.audioList`)
                        // console.log( that.audioList)
                        if (res.resultBody.answerCoordinate) {
                            that.center = res.resultBody.answerCoordinate.split(',')
                            that.marker.position = res.resultBody.answerCoordinate.split(',')
                        }
                        // that.questionList = JSON.parse(res.resultBody.tbExamPaper.paperjson).questionsList
						let paperjson = JSON.parse(res.resultBody.tbExamPaper.paperjson)
						// console.log('paperjson :>> ', paperjson);
						// console.log('that.questionList :>> ', that.questionList);
						
						that.data.questionsList = paperjson.questionsList;
                        that.userId = res.resultBody.userId
                        that.audioInfo = res.resultBody
						SetAnswer(res.resultBody.result, that.data.questionsList, that.$refs)
					}
				}
			};
			this.$util.request(params);
		},
		viewAuditReport() {
			this.$router.push({
				path: '/wjmanage/wjpub/auditReport',
				query: {
					id: this.wid
				}
			});
		},
	},
	beforeDestroy() {
		clearInterval(this.audioTime);
	}
}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		min-width: 1070px;
	}
	.content-box {
		background-color: #fff;
		border-radius: 5px;
		padding: 0 24px 24px 24px;
		.content-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			.label {
				font-size: 16px;
				line-height: 35px;
			}
			.label::before {
				content: '';
				display: inline-block;
				width: 4px;
				height: 16px;
				background-color: #0088ee;
				margin-right: 10px;
			}
			.view {
				font-size: 14px;
				color: #0088ee;
				cursor: pointer;
			}
		}
		.content-body {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			.question {
				height: 500px;
				width: calc(100% - 120px - 20px);
				overflow: auto;
				margin-top: 10px;
			}
			.img-box {
				width: 120px;
				height: 104px;
				border-radius: 5px;
				.img {
					width: 100%;
					height: 100%;
					border-radius: 5px;
				}
			}
			.map-box {
				width: 120px;
				height: 104px;
				border-radius: 5px;
				margin-top: 20px;
				background: url('../assets/mapimg.png') no-repeat;
				position: relative;
				.map-icon {
					width: 30px;
					height: 30px;
					position: absolute;
					top: 20px;
					left: 40px;
					background: url('../assets/position-icon.png') no-repeat;
				}
			}
		}
		.content-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 20px;
			.audio-box {
				font-size: 14px;
				width: 100%;
				height: 36px;
				padding-right: 20px;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				.audio-icon{
					font-size: 22px;
					margin-left: 10px;
					cursor: pointer;
					color: #606266;
				}
				.slider {
					display: inline-block;
					width: 62%;
					margin: 0 20px;
				}
				.next {
					margin-left: 10px;
				}
				.next,
				.last {
					cursor: pointer;
				}
				.num {
					display: inline-block;
					margin-left: 10px;
					color: #c0c0c0;
					font-size: 14px;
					font-weight: bold;
				}
			}
			.btn {
				width: 240px;
			}
		}
		.scroll-body {
			height: 500px;
		}
		.sample-body {
			font-size: 14px;
			.name {
				display: inline-block;
				margin: 10px 20px;
			}
		}
		.to-be-reviewed-body {
			.row + .row {
				margin-top: 20px;
			}
			/deep/.el-date-editor--datetimerange.el-input__inner {
				width: 100%;
			}
			.btn {
				display: flex;
				justify-content: flex-end;
			}
			.tag-box {
				.tag {
					display: inline-block;
					width: 50%;
					line-height: 32px;
					font-size: 14px;
					span {
						// cursor: pointer;
						color: #409EFF;
					}
				}
			}
		}
	}
	.amap-demo {
		width: 100%;
		height: 300px;
	}
	.field-content{
		display: flex;
		align-items: start;
		
	}
	.field-box + .field-box {
		margin-left: 20px;
	}
	.field-box {
		width: 50%;
		.el-card {
			margin-top: 20px;
			height: 500px;
			overflow-y: scroll;
		}
		.draggable,
		.draggable2{
			height: calc(500px - 40px);
		}
		.tips {
			color: #c0c0c0;
		}
		.handle{
			line-height: 32px;
			border-radius: 4px;
			padding-left: 10px;
			border: 1px solid #EBEEF5;
			box-sizing: border-box;
			cursor: all-scroll;
		}
		.handle+.handle{
			margin-top: 10px;
		}
		
		.handle[draggable="true"]{
			border: 1px solid #0080ff;
		}
			.handle[draggable="false"]{
			border: 1px solid #EBEEF5;
		}
	}
	.page-box {
		margin-top: 20px;
		text-align: center;
	}
	.details_header {
		// max-width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #0080ff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			// color: #333333;
			color: #fff;
			font-size: 16px;
			padding: 0px 30px;
		}
		margin-bottom: 20px;
		cursor: pointer;
	}
	/deep/.el-table .success-row {
		background: #f5f7fa;
	}
	.remarks-dialog-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>
<style>
	.content{
		margin: 0 !important;
    	width: 100% !important;
	}
</style>